<template>
  <!-- exhibition-product .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb> 
          <BreadcrumbItem>Exhibitor Manual</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">Exhibitor Manual</div>
      </div>
      <!-- <div class="header-tool-box">
        <div class="htb-item">
          <span class="htb-add">+</span>
          <span>全部下载</span>
        </div>
      </div> -->
    </div>
    <div class="header-tabs">
      <exhibitionProductItem
        ref="exhibitionProductItem"
        @edit-product="editShow" 
        @showNum="setNume"
        @showAdd="showAdd()"
      />
    </div>
    <Contact />
  </div>
</template>

<script>
import exhibitionProductItem from "./subpages/exhibition-product-item/exhibition-product-item.vue";

import Contact from "@components/Contact/Contact";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "exhibition-down",
  data() {
    return {     
      num: 0, 
    };
  },
  components: {
    exhibitionProductItem,
    Contact
  },
  created() { 
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      list: "productModule/list",
      pageInfo: "productModule/pageInfo",
      current: "productModule/current",
      exhibition: "loginModule/getExhibition"
    }) 
  },
  methods: {
    initNewProduct() {
      this.newProduct = {
        compId: this.company.id,
        agentId: this.company.agentId
      };
    }, 
    ...mapActions({
      getList: "productModule/getList", 
      getOne: "productModule/getOne",
      remove: "productModule/remove"
    }),  
    cancel(name) {
      this.$refs[name].handleReset();
    },
    add(name) {
      this.initNewProduct();
      this.addProductFlag = true;
    },
    async editShow(id) {
      this.editFlag = true;
      await this.getOne({ data: { id: id } });
    },
    exportInfo(name) {
      // 导出数据
      this.$refs[name].exportInfo();
    },
    setNume(num) {
      this.num = num;
    } 
  }
};
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
